(() => {
  const init = (root) => {
    if (root.dataset.storiesReady) return;
    root.dataset.storiesReady = 'true';
    const reel = root.querySelector('[data-spc-reel]');
    if (!reel) return;
    const items = [...reel.querySelectorAll('.spc__reel-item')].map(el => el.dataset);
    if (!items.length) return;
    const q = selector => reel.querySelector(selector);
    const videos = [...reel.querySelectorAll('video')];
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const play = q('[data-reel-play]');
    const mute = q('[data-reel-mute]');
    const status = q('[data-reel-status]');
    let index = 0, visible = false, paused = reduced.matches, muted = true;
    const dots = q('[data-reel-dots]');
    const activeVideo = () => items[index].videoId ? document.getElementById(items[index].videoId) : null;
    const syncButtons = () => {
      const video = activeVideo();
      const playing = video && !video.paused;
      play.textContent = playing ? 'Pause' : 'Abspielen';
      play.setAttribute('aria-label', playing ? 'Video pausieren' : 'Video abspielen');
      play.setAttribute('aria-pressed', String(!!playing));
      mute.setAttribute('aria-label', muted ? 'Ton einschalten' : 'Ton ausschalten');
      mute.setAttribute('aria-pressed', String(!muted));
      mute.classList.toggle('is-unmuted', !muted);
    };
    const syncPlayback = () => {
      const active = activeVideo();
      videos.forEach(v => { if (v !== active) v.pause(); });
      if (active) {
        active.muted = muted;
        if (visible && !document.hidden && !paused) active.play().catch(syncButtons);
        else active.pause();
      }
      syncButtons();
    };
    const render = () => {
      const item = items[index];
      [['topic','topic'],['init','init'],['name','name'],['followers','followers'],['ago','ago'],['views','views']].forEach(([selector,key]) => {
        const el=q('[data-reel-'+selector+']'); if (el) el.textContent=item[key] || '';
      });
      [['sport','sport'],['reason','reason'],['quote','benefit'],['name','name'],['initials','init']].forEach(([selector,key]) => {
        const el=root.querySelector('[data-person-'+selector+']'); if(el) el.textContent=item[key] || '';
      });
      root.querySelectorAll('[data-person-avatar], [data-reel-avatar]').forEach(img => { img.src = item.avatar || item.img; img.alt = item.name; });
      root.querySelectorAll('[data-person-verified]').forEach(badge => { badge.hidden = item.verified !== 'true'; });
      const sportIcons = {'Bodybuilding':'dumbbell','Krafttraining':'dumbbell','Radsport':'bike','HYROX':'kettlebell','Fitness & Coaching':'activity','Bikini-Fitness':'medal'};
      const reasonIcons = {'Nach dem Beintraining':'clock','Recovery nach dem Sport':'clock','Anwendung zuhause':'home','Auch auf Reisen':'plane','Pause im Gym':'dumbbell','Auszeit auf dem Sofa':'sofa'};
      [['sport',sportIcons[item.sport] || 'activity'],['reason',reasonIcons[item.reason] || 'clock']].forEach(([slot,icon]) => {
        root.querySelector('[data-person-'+slot+'-icon] use').setAttribute('href','#'+root.id+'-icon-'+icon);
      });
      root.querySelector('[data-person-testimonial]').hidden = !item.benefit;
      q('.spc__story-meta').hidden = !item.ago && !item.views;
      const img = q('[data-reel-img]');
      img.src = item.img; img.alt = item.name + ' mit ' + (root.dataset.productName || 'STARKBOOTS');
      [['b0',-1],['b1',1]].forEach(([slot,offset]) => {
        q('[data-reel-'+slot+']').src=items[(index+offset+items.length)%items.length].img;
      });
      videos.forEach(v => {v.pause();v.style.display=v===activeVideo()?'block':'none';});
      play.hidden = !activeVideo(); mute.hidden = !activeVideo();
      mute.classList.toggle('is-visible', !!activeVideo());
      [...dots.children].forEach((dot,i)=>{
        dot.classList.toggle('is-active',i===index);
        dot.setAttribute('aria-current',String(i===index));
      });
      status.textContent=(index+1)+' von '+items.length+' · '+item.name;
      syncPlayback();
    };
    const go = next => {index=(next+items.length)%items.length;render();};
    items.forEach((item,i)=>{
      const dot=document.createElement('button');dot.type='button';dot.className='nav-dot';
      dot.setAttribute('aria-label','Video von '+item.name);dot.addEventListener('click',()=>go(i));dots.append(dot);
    });
    q('[data-reel-prev]').addEventListener('click',()=>go(index-1));
    q('[data-reel-next]').addEventListener('click',()=>go(index+1));
    play.addEventListener('click',()=>{paused=!!activeVideo()&&!activeVideo().paused;syncPlayback();});
    mute.addEventListener('click',()=>{muted=!muted;syncPlayback();});
    reel.addEventListener('keydown',e=>{
      if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();go(index+(e.key==='ArrowLeft'?-1:1));}
    });
    let touchX;
    const stage=q('.spc__stage');
    stage.addEventListener('touchstart',e=>{touchX=e.touches[0].clientX;},{passive:true});
    stage.addEventListener('touchend',e=>{const delta=e.changedTouches[0].clientX-touchX;if(Math.abs(delta)>50)go(index+(delta<0?1:-1));},{passive:true});
    videos.forEach(v=>{v.addEventListener('play',syncButtons);v.addEventListener('pause',syncButtons);v.addEventListener('error',()=>{v.style.display='none';paused=true;syncButtons();});});
    const onVisibility=()=>syncPlayback();
    const onMotion=()=>{if(reduced.matches)paused=true;syncPlayback();};
    document.addEventListener('visibilitychange',onVisibility);
    reduced.addEventListener('change',onMotion);
    const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;syncPlayback();},{threshold:.2});
    observer.observe(reel);
    root.addEventListener('shopify:section:unload',()=>{observer.disconnect();videos.forEach(v=>v.pause());document.removeEventListener('visibilitychange',onVisibility);reduced.removeEventListener('change',onMotion);},{once:true});
    render();
  };
  document.querySelectorAll('[data-sf-boots-stories]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-sf-boots-stories]').forEach(init));
})();
